import { render, staticRenderFns } from "./ProductCategoryTable.vue?vue&type=template&id=e40a53b0&scoped=true&"
import script from "./ProductCategoryTable.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40a53b0",
  null
  
)

export default component.exports